import React from 'react';

import Stack, { StackProps } from '@components/Stack';

interface SensitiveViewProps extends StackProps {
    sensitive?: boolean;
}

const SensitiveView: React.FC<SensitiveViewProps> = ({ sensitive: _sensitive, ...props }) => (
    <Stack {...props} />
);

export default SensitiveView;
